import config from "@/config"
import http from "@/utils/request"

export default {
	getList: {
		url: `${config.API_URL}/scene/getList`,
		name: "获取分身列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	changeName: {
		url: `${config.API_URL}/scene/changeName`,
		name: "修改分身名称",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},

	delete: {
		url: `${config.API_URL}/scene/delete`,
		name: "分身删除",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},

	save: {
		url: `${config.API_URL}/scene/save`,
		name: "创建分身",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
}
